<template>
  <div>
    <!-- 常用车辆  新增 编辑-->
    <el-row>
      <el-col :span="24">
        <el-form
          :model="ruleForm"
          :inline="true"
          :rules="rules"
          ref="ruleForm"
          label-width="160px"
        >
          <el-form-item label="司机身份证号:" prop="driverIdCard">
            <el-input
              v-model.trim="ruleForm.driverIdCard"
              placeholder="请输入"
              maxlength="18"
              clearable
              @blur="idBlur('driverIdCard')"
            ></el-input>
          </el-form-item>
          <el-form-item label="司机姓名:" prop="driverName">
            <el-input
              v-model.trim="ruleForm.driverName"
              placeholder="请输入"
              maxlength="10"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="司机手机号:" prop="driverPhone">
            <el-input
              v-model.trim="ruleForm.driverPhone"
              placeholder="请输入"
              maxlength="11"
              clearable
              @blur="phoneBlur('driverPhone')"
            ></el-input>
          </el-form-item>
          <el-form-item label="排放标准:" prop="emissionStandard">
            <el-select
              v-model.trim="ruleForm.emissionStandard"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in emissionStandardList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车牌号:" prop="licensePlateNum">
            <el-input
              :disabled="disab"
              v-model.trim="ruleForm.licensePlateNum"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="挂车车牌(箱号):">
            <el-input
              v-model.trim="ruleForm.trailerNum"
              placeholder="请输入"
              @blur="blurTrailerNum()"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="运输类型:" prop="transportType">
            <el-select
              v-model="ruleForm.transportType"
              clearable
              placeholder="请选择"
              @change="getTransportTypeChange"
            >
              <el-option
                v-for="(item, index) in transportTypeList"
                :label="item.label"
                :value="item.value"
                :key="index"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="ruleForm.transportType == '1'"
            label="押运员姓名:"
            prop="escortsName"
          >
            <el-input
              v-model.trim="ruleForm.escortsName"
              placeholder="请输入"
              maxlength="10"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="ruleForm.transportType == '1'"
            label="押运员手机号:"
            prop="escortsPhone"
          >
            <el-input
              v-model.trim="ruleForm.escortsPhone"
              placeholder="请输入"
              maxlength="11"
              clearable
              @blur="phoneBlur('escortsPhone')"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="ruleForm.transportType == '1'"
            label="押运员身份证号:"
            prop="escortsIdCardNum"
          >
            <el-input
              v-model.trim="ruleForm.escortsIdCardNum"
              placeholder="请输入"
              maxlength="18"
              clearable
              @blur="idBlur('escortsIdCardNum')"
            ></el-input>
          </el-form-item>
          <template v-if="isCarrier">
            <!-- prop="safetyValidityPeriod" -->
            <el-form-item
              v-if="ruleForm.transportType == '1'"
              label="罐体安全检查有效期:"
              prop="safetyValidityPeriod"
            >
              <el-date-picker
                v-model="ruleForm.safetyValidityPeriod"
                type="date"
                clearable
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="车辆识别码:" prop="vin">
              <el-input
                v-model.trim="ruleForm.vin"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="车辆类型:" prop="vehicleType">
              <el-select v-model="ruleForm.vehicleType" placeholder="请选择">
                <el-option
                  v-for="(item, index) in vehicleTypeList"
                  :label="item.label"
                  :value="item.value"
                  :key="index"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="常规装载品种:" prop="conventionLoadType">
              <el-input
                v-model.trim="ruleForm.conventionLoadType"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="荷载量:" prop="loadWeight">
              <el-input
                v-model.trim="ruleForm.loadWeight"
                type="number"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="车辆所属公司:" prop="carBelongTo">
              <el-input
                v-model.trim="ruleForm.carBelongTo"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="行驶证注册日期:" prop="dlRegistrateTime">
              <el-date-picker
                v-model="ruleForm.dlRegistrateTime"
                type="date"
                clearable
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="行驶证有效期:" prop="licenseValidityPeriod">
              <el-date-picker
                v-model="ruleForm.licenseValidityPeriod"
                type="date"
                clearable
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="燃油类型:" prop="fuelType">
              <el-select
                v-model="ruleForm.fuelType"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in fuelTypeList"
                  :label="item.label"
                  :value="item.value"
                  :key="index"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="车牌颜色:" prop="licensePlateColour">
              <el-select
                v-model="ruleForm.licensePlateColour"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in licensePlateColourList"
                  :label="item.label"
                  :value="item.value"
                  :key="index"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="车长:">
              <el-input
                v-model.trim="ruleForm.length"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="车宽:">
              <el-input
                v-model.trim="ruleForm.width"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="车高:">
              <el-input
                v-model.trim="ruleForm.high"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="车重:" prop="weight">
              <el-input
                v-model.trim="ruleForm.weight"
                type="number"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="排量:">
              <el-input
                v-model.trim="ruleForm.displacement"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="功率:">
              <el-input
                v-model.trim="ruleForm.power"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-col :span="24">
              <el-form-item
                label="行驶证附件:"
                prop="licenseUrlXs"
                v-model="ruleForm.licenseUrlXs"
              >
                <el-upload
                  class="avatar-uploader"
                  :action="upload"
                  :show-file-list="false"
                  :on-success="getLicenseUrlXs"
                  ref="uploadllalal"
                  :before-upload="onlyImages"
                >
                  <img
                    v-if="ruleForm.licenseUrlXs"
                    :src="ruleForm.licenseUrlXs"
                    class="avatar"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <div class="el-upload__tip">
                  只能上传jpg/png文件，且不超过10Mb
                </div>
              </el-form-item>

              <el-form-item
                label="驾驶证附件:"
                prop="licenseUrlJs"
                v-model="ruleForm.licenseUrlJs"
              >
                <el-upload
                  class="avatar-uploader"
                  :action="upload"
                  :show-file-list="false"
                  :on-success="getLicenseUrlJs"
                  ref="uploadllalal"
                  :before-upload="onlyImages"
                >
                  <img
                    v-if="ruleForm.licenseUrlJs"
                    :src="ruleForm.licenseUrlJs"
                    class="avatar"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <div class="el-upload__tip">
                  只能上传jpg/png文件，且不超过10Mb
                </div>
              </el-form-item>

              <el-form-item
                label="安全员证附件:"
                v-model="ruleForm.licenseUrlAqy"
              >
                <el-upload
                  class="avatar-uploader"
                  :action="upload"
                  :show-file-list="false"
                  :on-success="getLicenseUrlAqy"
                  ref="uploadllalal"
                  :before-upload="onlyImages"
                >
                  <img
                    v-if="ruleForm.licenseUrlAqy"
                    :src="ruleForm.licenseUrlAqy"
                    class="avatar"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <div class="el-upload__tip">
                  只能上传jpg/png文件，且不超过10Mb
                </div>
              </el-form-item>
            </el-col>
          </template>
          <el-col :span="24">
            <el-form-item label=" ">
              <el-button type="primary" @click="submit">保存</el-button>
              <el-button type="primary" @click="$router.back()">返回</el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-col>
      <el-col :span="24" class="conBg_Title" v-if="$route.query.carDetail"
        >环保备案
        <el-switch
          v-model="offSwitch"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-col>
      <el-col :span="24">
        <putOnRecord
          v-if="offSwitch"
          :showHide="true"
          :isCarrier="isCarrier"
        ></putOnRecord>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { baseGateway } from "@/api/base";
import {
  emissionStandardList,
  vehicleTypeList,
  transportTypeList,
  fuelTypeList,
  licensePlateColourList,
} from "./columns";
export default {
  props: {
    // 是否承运商
    isCarrier: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    // 新增 账户账号表单验证
    let validLicensePlateNum = (rule, value, callback) => {
      console.log("🚀 ~ validLicensePlateNum ~ value:", value);
      let reg =
        /(^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$)/;
      // var xreg =
      // /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$)|([A-Z]{2}[0-9]{4}$))/;
      var xreg =
        /^[\u4e00-\u9fa5]{1}[A-Z]{1}[A-Z0-9]{5}[A-Z0-9\u4e00-\u9fa5]{1}$/;
      //  /^[\u4e00-\u9fa5]{1}[A-Z]{1}[A-HJ-Z]{1}[A-Z0-9]{4}[A-Z0-9\u4e00-\u9fa5]{1}$/;
      // var xreg =
      //   /^[\u4e00-\u9fa5]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9\u2581-\u258F]{1}$/;
      console.log(
        "🚀 ~ validLicensePlateNum ~ !xreg.test(value):",
        xreg.test(value)
      );
      console.log(
        "🚀 ~ validLicensePlateNum ~ !reg.test(value):",
        reg.test(value)
      );
      console.log(
        "🚀 ~ validLicensePlateNum ~ !reg.test(value) && !xreg.test(value):",
        !reg.test(value) && !xreg.test(value)
      );

      if (!reg.test(value) && !xreg.test(value)) {
        callback(new Error("请输入正确的车牌号格式(例: 沪A12345)"));
      } else {
        callback();
      }
    };
    let validLicensePlateNum2 = (rule, value, callback) => {
      let reg = /^[\u4E00-\u9FA5]{0,}$/;
      if (!reg.test(value)) {
        callback(new Error("姓名格式有误(限中文)"));
      } else {
        callback();
      }
    };
    return {
      emissionStandardList,
      vehicleTypeList,
      transportTypeList,
      fuelTypeList,
      licensePlateColourList,
      upload: `${baseGateway()}/chem-gateway/chem-loms/file/upload`,
      ruleForm: {
        driverIdCard: "", //司机身份证号
        driverName: "", //司机姓名
        driverPhone: "", //司机手机号
        emissionStandard: "", //排放标准
        licensePlateNum: "", //车牌号
        trailerNum: "", //挂车车牌

        escortsName: "", //押运员姓名
        escortsPhone: "", //押运员手机号
        escortsIdCardNum: "", //押运员身份证号
        vin: "", //车辆识别码
        vehicleType: "", //车辆类型
        transportType: "", //运输类型
        conventionLoadType: "", //常规装载品种
        loadWeight: "", //荷载量
        carBelongTo: "", //车辆所属公司
        safetyValidityPeriod: "", //安全检查有效期
        dlRegistrateTime: "", //行驶证注册日期
        licenseValidityPeriod: "", //行驶证有效期
        fuelType: "", //燃油类型
        licensePlateColour: "", //车牌颜色
        length: "", //车长
        width: "", //车宽
        high: "", //车高
        weight: "", //车重
        displacement: "", //排量
        power: "", //功率
        licenseUrlXs: "", //行驶证URL
        licenseUrlJs: "", //驾驶证URL
        licenseUrlAqy: "", //安全员证URL
        identity : "",
      },
      // 常用车辆校验
      rules: {
        driverIdCard: [
          { required: true, message: "请输入司机身份证号", trigger: "blur" },
        ],
        driverName: [
          { required: true, message: "请输入司机姓名", trigger: "blur" },
          { validator: validLicensePlateNum2, trigger: "blur" },
        ],
        driverPhone: [
          { required: true, message: "请输入司机手机号", trigger: "blur" },
        ],

        escortsIdCardNum: [
          { required: true, message: "请输入押运员身份证号", trigger: "blur" },
        ],
        escortsName: [
          { required: true, message: "请输入押运员姓名", trigger: "blur" },
          { validator: validLicensePlateNum2, trigger: "blur" },
        ],
        escortsPhone: [
          { required: true, message: "请输入押运员手机号", trigger: "blur" },
        ],

        emissionStandard: [
          { required: true, message: "请选择排放标准", trigger: "change" },
        ],
        licensePlateNum: [
          { required: true, message: "请输入车牌号", trigger: "blur" },
          { validator: validLicensePlateNum, trigger: "blur" },
        ],
        vin: [{ required: true, message: "请输入车辆识别码", trigger: "blur" }],
        vehicleType: [
          { required: true, message: "请选择车辆类型", trigger: "change" },
        ],
        transportType: [
          { required: true, message: "请选择运输类型", trigger: "change" },
        ],
        conventionLoadType: [
          { required: true, message: "请输入常规装载品种", trigger: "blur" },
        ],
        loadWeight: [
          { required: true, message: "请输入荷载量", trigger: "blur" },
        ],
        carBelongTo: [
          { required: true, message: "请输入车辆所属公司", trigger: "blur" },
        ],
        safetyValidityPeriod: [
          {
            required: true,
            message: "请选择安全检查有效期",
            trigger: "change",
          },
        ],
        dlRegistrateTime: [
          {
            required: true,
            message: "请选择行驶证注册日期",
            trigger: "change",
          },
        ],
        licenseValidityPeriod: [
          { required: true, message: "请选择行驶证有效期", trigger: "change" },
        ],
        fuelType: [
          { required: true, message: "请选择燃油类型", trigger: "change" },
        ],
        licensePlateColour: [
          { required: true, message: "请选择车牌颜色", trigger: "change" },
        ],
        weight: [{ required: true, message: "请输入车重", trigger: "blur" }],
        licenseUrlXs: [
          {
            required: true,
            message: "请上传行驶证附件",
            trigger: ["change", "blur"],
          },
        ],
        licenseUrlJs: [
          {
            required: true,
            message: "请上传驾驶证附件",
            trigger: ["change", "blur"],
          },
        ],
      },

      disab: false,
      offSwitch: false, //环保备案开关
    };
  },
  mounted() {
    if (this.$route.query.carDetail) {
      let data = JSON.parse(this.$route.query.carDetail);
      // console.log(data);
      if (data.licensePlateNum) {
        // if(this.isCarrier){
        this.ruleForm = { ...this.ruleForm, ...data };
        this.ruleForm.vehicleType =
          this.ruleForm.vehicleType == null ? "" : this.ruleForm.vehicleType;
        this.ruleForm.transportType =
          this.ruleForm.transportType == null
            ? ""
            : this.ruleForm.transportType;
        this.ruleForm.safetyValidityPeriod =
          this.ruleForm.safetyValidityPeriod == null
            ? ""
            : this.ruleForm.safetyValidityPeriod;
        this.ruleForm.dlRegistrateTime =
          this.ruleForm.dlRegistrateTime == null
            ? ""
            : this.ruleForm.dlRegistrateTime;
        this.ruleForm.licenseValidityPeriod =
          this.ruleForm.licenseValidityPeriod == null
            ? ""
            : this.ruleForm.licenseValidityPeriod;
        this.ruleForm.fuelType =
          this.ruleForm.fuelType == null ? "" : this.ruleForm.fuelType;
        this.ruleForm.licensePlateColour =
          this.ruleForm.licensePlateColour == null
            ? ""
            : this.ruleForm.licensePlateColour;
        // }else{
        //   this.ruleForm.driverIdCard=data.driverIdCard//司机身份证号
        //   this.ruleForm.driverName=data.driverName//司机姓名
        //   this.ruleForm.driverPhone=data.driverPhone//司机手机号
        //   this.ruleForm.emissionStandard=data.emissionStandard//排放标准
        //   this.ruleForm.licensePlateNum=data.licensePlateNum//车牌号
        //   this.ruleForm.trailerNum=data.trailerNum//挂车车牌
        //   this.ruleForm.transportType=data.transportType//
        //   this.ruleForm.escortsName=data.escortsName||'',//押运员姓名
        //   this.ruleForm.escortsPhone=data.escortsPhone||'',//押运员手机号
        //   this.ruleForm.escortsIdCardNum=data.escortsIdCardNum||''//押运员身份证号
        // }

        this.disab = true;
      } else {
        this.disab = false;
      }
    } else {
      this.disab = false;
    }
  },
  methods: {
    getTransportTypeChange() {
      this.ruleForm.escortsName = ""; //押运员姓名
      this.ruleForm.escortsPhone = ""; //押运员手机号
      this.ruleForm.escortsIdCardNum = ""; //押运员身份证号
    },
    blurTrailerNum() {
      // let val=this.ruleForm
      // let reg =/(^[A-Z]{1}[0-9]{4}$)/;
      //  if (!reg.test(val.trailerNum)&&val.trailerNum) {
      //   this.$message.warning("挂车车牌格式有误(例: E1234)，请重新输入");
      //   this.ruleForm.trailerNum = "";
      // }
    },
    // 身份证号校验
    idBlur(val) {
      const IDRe18 =
        /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      const IDRe15 =
        /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/;
      if (
        !IDRe18.test(this.ruleForm[val]) &&
        !IDRe15.test(this.ruleForm[val]) &&
        this.ruleForm[val]
      ) {
        this.$message.warning("身份证号格式有误，请重新输入");
        this.ruleForm[val] = "";
      }
    },
    // 手机号格式
    phoneBlur(val) {
      const mobile = /^1[3-9]\d{9}$/;
      if (!mobile.test(this.ruleForm[val])) {
        this.$message.warning("手机号格式有误，请重新输入");
        this.ruleForm[val] = "";
      }
    },
    // 提交
    submit() {
      this.$refs.ruleForm.validate((boo) => {
        if (boo) {
          let paramsData = { ...this.ruleForm };
          paramsData.safetyValidityPeriod =
            paramsData.safetyValidityPeriod == null
              ? ""
              : paramsData.safetyValidityPeriod;
          let urlPath = "";
          if (this.isCarrier) {
            paramsData.identity=4
            urlPath = this.$api.carrier.postAddCommonVehicle(paramsData);
          } else {
            urlPath = this.$api.carrier.postSaveCommonVehicle(paramsData);
          }
          urlPath.then((res) => {
            // console.log(res,'新增、编辑常用车辆')
            if (res.status == 200) {
              this.$message.success(res.data);
              this.$router.back();
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },

    // 上传成功   行驶证URL
    getLicenseUrlXs(response, file, fileList) {
      // console.log(response);
      if (response.status == 200) {
        this.ruleForm.licenseUrlXs = response.data;
        this.$refs.ruleForm.clearValidate("licenseUrlXs");
      } else {
        this.$message.error("上传失败");
      }
    },
    // 上传成功  驾驶证URL
    getLicenseUrlJs(response, file, fileList) {
      // console.log(response);
      if (response.status == 200) {
        this.ruleForm.licenseUrlJs = response.data;
        this.$refs.ruleForm.clearValidate("licenseUrlJs");
      } else {
        this.$message.error("上传失败");
      }
    },
    // 上传成功  安全员证URL
    getLicenseUrlAqy(response, file, fileList) {
      // console.log(response);
      if (response.status == 200) {
        this.ruleForm.licenseUrlAqy = response.data;
      } else {
        this.$message.error("上传失败");
      }
    },
    //只能上传图片
    onlyImages(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png"; //image/png
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isJPG) {
        this.$message.error("只能上传文件格式为jpeg,png的!");
      } else if (!isLt2M) {
        this.$message.error("上传图片大小不能超过10MB!");
      } else {
        this.$message({
          message: "正在上传中...",
          type: "info",
          duration: 2000,
        });
        // this.$message.info('正在上传文件中');
      }
      return isJPG && isLt2M;
    },
  },
};
</script>

<style scoped>
::v-deep .el-upload__tip {
  line-height: initial;
  margin-top: 0;
}
</style>
